<template>
<div>
  <h3 class="text-center mt-3 mb-4">Login</h3>

  <div class="row">
    <div class="col-6 offset-2">
      <b-form-group label-cols="5" label="Username" label-for="username" label-align-sm="right">
        <b-form-input id="username" v-model.trim="login.username" @keydown.native.enter.prevent="performLogin" :state="usernameState" aria-describedby="username-input-feedback"></b-form-input>
        <b-form-invalid-feedback id="username-input-feedback" class="text-right">{{usernameError}}</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label-cols="5" label="Password" label-for="password" label-align-sm="right">
        <b-form-input id="password" v-model="login.password" type="password" @keydown.native.enter.prevent="performLogin" :state="passwordState" aria-describedby="password-input-feedback"></b-form-input>
        <b-form-invalid-feedback id="password-input-feedback" class="text-right">{{passwordError}}</b-form-invalid-feedback>
      </b-form-group>
      <div class="row">
        <div class="col offset-5">
          <b-alert v-model="showLoginError" variant="danger" dismissible>
            {{login.error}}
          </b-alert>
        </div>
      </div>
    </div>
  </div>
  <div class="row ml-2 text-center">
    <div class="col">
      <b-button variant="primary" class="mt-2 mb-3" @click="performLogin">Login</b-button>
      <p><a href="#" v-on:click.stop.prevent="openForgotPasswordModal">Forgot your password?</a></p>
      <p><a href="#" v-on:click.stop.prevent="openForgotUsernameModal">Forgot your username?</a></p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <p>Tips:</p>
      <ul>
        <li>Your username is usually name.surname or an email (for older accounts).</li>
        <li>If you are a principal investigator that was registered to IA2 services and this is the first time you are using this tool your password is any password of your older programs. If no password is working you can always reset it clicking on
          the "Forgot you password?" link.</li>
        <li>This form is for IA2 accounts. If you have an INAF-IDEM account please refer to the following link for reset that password: <a href="https://www.ced.inaf.it/passwd/reset.php" target="_blank">https://www.ced.inaf.it/passwd/reset.php</a>
        </li>
      </ul>
    </div>
  </div>
  <ForgotPasswordModal />
  <ForgotUsernameModal />
</div>
</template>

<script>
import client from 'api-client';
import ForgotPasswordModal from './ForgotPasswordModal.vue';
import ForgotUsernameModal from './ForgotUsernameModal.vue';

export default {
  name: 'Login',
  components: {
    ForgotPasswordModal,
    ForgotUsernameModal
  },
  data() {
    return {
      usernameError: null,
      passwordError: null
    }
  },
  computed: {
    login() { return this.$store.state.login; },
    usernameState() { return this.usernameError ? false : null; },
    passwordState() { return this.passwordError ? false : null; },
    showLoginError: {
      get() { return this.$store.state.login.error !== null },
      set(value) {
        if (!value) {
          this.$store.commit('setLoginError', null);
        }
        return value;
      }
    }
  },
  methods: {
    openForgotPasswordModal() {
      this.$bvModal.show('forgot-password-modal');
    },
    openForgotUsernameModal() {
      this.$bvModal.show('forgot-username-modal');
    },
    performLogin() {
      this.usernameError = null;
      this.passwordError = null;
      this.$store.commit('setLoginError', null);
      if (!this.login.username) {
        this.usernameError = "Field is required";
      }
      if (!this.login.password) {
        this.passwordError = "Field is required";
      }
      if (this.login.username && this.login.password) {
        client.login(this.login.username, this.login.password)
          .then(() => {
            this.$store.commit('setLoggedIn', true);
          })
          .catch(res => {
            this.$store.commit('setLoginError', res.message);
          });
      }
    }
  }
}
</script>
